import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { createRoot } from "react-dom/client";
import { useSensorsMap } from "../../contexts/SensorsMapProvider";
import { RxCross2 } from "react-icons/rx";

const SensorGraphOverlay = () => {
	const map = useMap();
	const { state, dispatch, ACTIONS } = useSensorsMap();

	useEffect(() => {
		const control = L.control({ position: "bottomright" });

		control.onAdd = () => {
			const container = L.DomUtil.create("div", "leaflet-control-container");
			container.style.width = "300px";
			container.style.maxHeight = "300px";
			container.style.overflowY = "auto";
			container.style.background = "rgba(255, 255, 255, 0.95)";
			container.style.borderRadius = "8px";
			container.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)";
			container.style.padding = "8px";
			container.style.boxSizing = "border-box";

			container.className = "hidden lg:block";

			// Impedisce che il controllo interferisca con la mappa
			L.DomEvent.disableClickPropagation(container);
			L.DomEvent.disableScrollPropagation(container);

			// Monta contenuto React dentro al container
			const root = createRoot(container);
			root.render(
				state.selectedSensor && (
					<div className="w-full max-w-full box-border h-full">
						<h3 className="text-xl mb-2 flex justify-between items-center overflow-hidden">
							<span className="flex items-start gap-2">
								<RxCross2
									className="self-start mt-1 cursor-pointer"
									onClick={() =>
										dispatch({ type: ACTIONS.CLEAR_SELECTED_SENSOR })
									}
								/>
								<span className="text-sm text-left truncate">
									{state.selectedSensor.name}
								</span>
							</span>
							<span className="text-purple-800 text-right truncate text-sm">
								{state.selectedSensor.type}
							</span>
						</h3>

						{state.selectedSensor.chart_link && (
							<div className="mt-2 flex justify-center">
								<img
									src={state.selectedSensor.chart_link}
									alt={`Grafico storico per ${state.selectedSensor.name}`}
									className="h-auto rounded-lg border"
									style={{ maxWidth: "100%" }}
									onLoad={() => {
										const spinner = container.querySelector("svg");
										if (spinner) spinner.style.display = "none";
									}}
									onError={() => {
										const spinner = container.querySelector("svg");
										if (spinner) spinner.style.display = "none";
									}}
								/>
							</div>
						)}
					</div>
				)
			);

			return container;
		};

		control.addTo(map);

		// Cleanup
		return () => {
			map.removeControl(control);
		};
	}, [map, state.selectedSensor, dispatch, ACTIONS]);

	return null;
};

export default SensorGraphOverlay;
